import type { CommunityPost } from "@/types";

export const communityPosts: CommunityPost[] = [
  {
    id: "post-1",
    title: "大家第一次被哪个萝莉角色治愈的？来聊聊吧",
    author: "奶油泡芙",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20smiling%20girl%2C%20soft%20pink%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-01&orientation=squarish",
    date: "2026-10-09",
    content: "我是从《薄荷气泡水》入坑的，苍井薄荷递饮料的那个镜头真的让我一下就哭出来了。你们呢？第一个治愈你的角色是谁？",
    replies: 42,
    likes: 156
  },
  {
    id: "post-2",
    title: "白羽雪乃新造型太美了吧！第二季真的等到了",
    author: "雪夜旅人",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20girl%20with%20silver%20hair%2C%20soft%20blue%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish",
    date: "2026-10-08",
    content: "看到先导 PV 的那一刻手都在抖。新造型的粉色披风真的太戳我了，感觉雪乃终于愿意拥抱这个世界了。",
    replies: 68,
    likes: 289
  },
  {
    id: "post-3",
    title: "求推荐冷系角色！最近有点上头",
    author: "夜行猫",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20girl%20with%20dark%20hair%2C%20soft%20purple%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish",
    date: "2026-10-06",
    content: "刚补完《幻夜学园》，黑羽夜这种毒舌又护短的类型太对我胃口了。还有类似的冷系角色推荐吗？",
    replies: 31,
    likes: 97
  },
  {
    id: "post-4",
    title: "自制了一套小猫咪咪的桌面壁纸，分享给大家",
    author: "像素工坊",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20girl%20with%20cat%20ears%2C%20soft%20peach%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-04&orientation=squarish",
    date: "2026-10-02",
    content: "整理了一下午，做了一套四种配色的小猫咪咪壁纸，都是 4K 的。喜欢的话在评论区说一声，我看看要不要出视频教程。",
    replies: 55,
    likes: 203
  },
  {
    id: "post-5",
    title: "《时雨之夏》结局到底算 HE 还是 BE？吵起来了",
    author: "梅雨不停",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20girl%20with%20rain%20theme%2C%20soft%20blue%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-05&orientation=squarish",
    date: "2026-09-29",
    content: "最后一集看完我整个人是懵的。开放式结局真的很难判断情绪，大家觉得时雨铃的告白算是成功了吗？",
    replies: 88,
    likes: 174
  },
  {
    id: "post-6",
    title: "第一次发帖，请问大家都在哪个平台追番呀",
    author: "新来的小朋友",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20cheerful%20girl%2C%20soft%20yellow%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-06&orientation=squarish",
    date: "2026-09-25",
    content: "刚入坑二次元不久，想问问大家平时都在哪里看番、找资讯。有没有比较全的资讯站推荐？",
    replies: 24,
    likes: 63
  },
  {
    id: "post-7",
    title: "月见铃兰的舞蹈考据帖，原来每个动作都有典故",
    author: "考据狂魔",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20elegant%20girl%2C%20soft%20lavender%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-07&orientation=squarish",
    date: "2026-09-20",
    content: "花了两周把《月下铃兰》里所有舞蹈片段逐帧扒了一遍，发现制作组参考了大量传统雅乐的姿态，整理成帖子分享给大家。",
    replies: 47,
    likes: 231
  },
  {
    id: "post-8",
    title: "有没有一起追《琥珀色的冒险》的小伙伴",
    author: "出发去远方",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20avatar%20icon%20of%20adventurous%20girl%2C%20soft%20orange%20background%2C%20kawaii%20anime%20style%2C%20circle%20portrait&width=200&height=200&seq=avatar-08&orientation=squarish",
    date: "2026-09-15",
    content: "每周期待更新的集合！琥珀莉可真的太有感染力了，看她的冒险自己都想背上包出门。一起追的一起举个手～",
    replies: 36,
    likes: 118
  }
];